module.exports = __webpack_public_path__ + "media/gong.4c5d309f.mp3";